import { render, staticRenderFns } from "./areaBlogList.vue?vue&type=template&id=3393a1d0&scoped=true"
import script from "./areaBlogList.vue?vue&type=script&lang=js"
export * from "./areaBlogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3393a1d0",
  null
  
)

export default component.exports